import { loadTemplate } from '@ag-grid-community/core/dist/cjs/utils/dom'
import { prettyFormatNumber } from '@helios/utils'
import { GenericTransaction, GenericTxSummary } from './generic-transaction'
import { TransactionsStatusBarBase } from './transactions-status-bar-base'
import { sumMarginEffectByCurrency } from './utils'

const template = `
      <div class="hs-transactions-status-bar hs-cwTransaction-marginEffect-status-bar hs-status-bar">
        <div class="value-container">
          <label >Margin:</label>
          <select class="form-control" id="margin-container">
          </select>
        </div>
      </div>
  `

export class CwTransactionsMarginEffectStatusBarComp extends TransactionsStatusBarBase {
  private readonly onCopyBinding = this.onCopyClipboardEvent.bind(this)

  constructor() {
    super(template)

    document.addEventListener('copy', this.onCopyBinding)
  }

  destroy() {
    super.destroy()
    document.removeEventListener('copy', this.onCopyBinding)
  }

  onRowSelectionChanged = (selection: GenericTransaction[]) => {
    this.setEmpty(selection)
    const allMargins = sumMarginEffectByCurrency(selection)

    const options = Array.from(allMargins.entries()).map(
      ([currCode, marginEffect]) =>
        loadTemplate(
          `<option>${prettyFormatNumber(marginEffect, 4)} ${currCode}</option>`,
        ),
    )

    const unitsEl = this.eGui.querySelector('#margin-container')
    if (unitsEl != null) {
      unitsEl.innerHTML = ''
      options.forEach(op => unitsEl.append(op))
    }
  }

  onSelectAllTransactions = (data?: GenericTxSummary) => {
    if (data !== undefined) {
      const allMargins = data.marginEffectByCurrencyCode
      const marginHtml: HTMLElement[] = []
      if (allMargins === undefined) return

      Object.entries(allMargins).forEach(([currCode, marginEffect]) => {
        marginHtml.push(
          loadTemplate(
            `<option>${prettyFormatNumber(
              marginEffect,
              4,
            )} ${currCode}</option>`,
          ),
        )
      })

      const unitsEl = this.eGui.querySelector('#margin-container')
      if (unitsEl != null) {
        unitsEl.innerHTML = ''
        marginHtml.forEach(op => unitsEl.append(op))
      }
    }
  }

  private onCopyClipboardEvent(event: ClipboardEvent) {
    const focusedElement = document.activeElement
    if (focusedElement?.id === 'margin-container') {
      event.preventDefault()
      // Assuming here that `focusedElement` is a select HTML element
      const selectElement = focusedElement as HTMLSelectElement
      const selectedOptionValue = selectElement.value
      const matchValue = selectedOptionValue.match(/-?[\d,]+(\.\d+)?/)
      event.clipboardData?.setData(
        'text/plain',
        matchValue ? matchValue[0] : '',
      )
    }
  }
}
